import { JOBS_URL } from '@/utils/constants'

const ISSUES = () => `${JOBS_URL}`
const ISSUE_BY_ID = (jobId: string) => `${ISSUES()}/${jobId}`
const ISSUE_TASK_BY_ID = (jobId: string, taskId: string) => `${ISSUES()}/${jobId}/tasks/${taskId}`

export default {
  ISSUES,
  ISSUE_BY_ID,
  ISSUE_TASK_BY_ID
}
